import { render, staticRenderFns } from "./SelectArticleCalculation.vue?vue&type=template&id=563868ce"
import script from "./SelectArticleCalculation.vue?vue&type=script&lang=js"
export * from "./SelectArticleCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports